module.exports = __webpack_public_path__ + "img/1.42f16cce.jpg";